'use strict';

require('./read-more-btn/read-more-btn');
require('./events-calendar/events-calendar');

angular.module('far.ui', [
  'far.ui.readMoreBtn',
  'far.ui.eventsCalendar'
]);
